import { filter } from 'lodash/fp';

export default function filterValidDesignText(option, materialId, coverpanel) {
  return filter((item) => {
    if (!item.ValidDesignTextGlobal) {
      // eslint-disable-next-line no-console
      console.error(`Excluding ${option} ${item.ItemNo} in material ${materialId} due to no ValidDesignTextGlobal`);
      return false;
    }
    return true;
  });
}
